module.exports = __webpack_public_path__ + "img/facebook.d65f66bb.png";